/* eslint-disable react/prop-types */
import { RouteComponentProps } from "@reach/router"
import { DocumentTitleOverride } from "@shared/primitive-components"
import { IFrame } from "./iframe"
import { usePolicyAndFleet } from "../contexts"
import { LowConnectivityBanner } from "../ui/components/LowConnectivityBanner"

interface PolicyDocumentsProps extends RouteComponentProps {
  policyId?: string
}

export const PolicyDocuments: React.FC<PolicyDocumentsProps> = ({ policyId }) => {
  const { policy, connectivity } = usePolicyAndFleet()

  return (
    <>
      {!!(connectivity.data || policy.connectivityRatio) && <LowConnectivityBanner policy={policy} />}
      <DocumentTitleOverride>Flock Motor | Documents</DocumentTitleOverride>
      <IFrame path={`policies/${policyId ?? policy.id}/documents`} />
    </>
  )
}
